import React, { Component } from 'react';
import { Form, Modal } from 'antd';

import SelectCustom from '../comm/SelectCustom';

const FormItem = Form.Item;
class ModalRelevance extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {}

  componentDidMount() {}

  handleOk = () => {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.onOk(values.customUuid);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Modal title="客户关联" onCancel={this.props.onCancel} onOk={this.handleOk} visible>
        <Form>
          <FormItem>
            {getFieldDecorator('customUuid', {
              rules: [{ required: true, message: '请选择客户!' }],
            })(
              <SelectCustom onChange={this.handleChange} />,
            )}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}
export default Form.create({ wrappedComponentRef: true })(ModalRelevance);



// WEBPACK FOOTER //
// ./src/components/incubator/income/ModalRelevance.js